import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { constants } from '../../devUtils';

const StyledNewsC = styled.div`
    width: 100%;
    background: ${(props) => props.theme.primaryColor};
    color: ${(props) => props.theme.whiteColor};
    height: 30px;
    text-align: center;
    font-size: 14px;
    line-height: 30px;
    display: none;
    @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
        font-size: 10px;
    };
    a{
        color: ${(props) => props.theme.whiteColor};
    }
.NewsC {
  width: 100%;
    position: relative;
    z-index: 0;
    @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
    };

}
.slide1,.slide2,.slide3,.slide4,.slide5 {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: -1;
}
.slide1 {
  
    animation:fade 8s infinite;
-webkit-animation:fade 8s infinite;

} 
.slide2 {
  
    animation:fade2 8s infinite;
-webkit-animation:fade2 8s infinite;
}
.slide3 {
    
    animation:fade3 8s infinite;
-webkit-animation:fade3 8s infinite;
}

@keyframes fade
{
  0%   {opacity:1}
  33.333% { opacity: 0}
  66.666% { opacity: 0}
  100% { opacity: 1}
}
@keyframes fade2
{
  0%   {opacity:0}
  33.333% { opacity: 1}
  66.666% { opacity: 0 }
  100% { opacity: 0}
}
@keyframes fade3
{
  0%   {opacity:0}
  33.333% { opacity: 0}
  66.666% { opacity: 1}
  100% { opacity: 0}
}
`;


function NewsCarousel() {
  return (
    <StyledNewsC>
      <div className="NewsC">
        <div className="slide1"><Link to={constants.LINK_PRESS}>Best Software Product – Enterprise Solutions at 27th Annual HYSEA Innovation Summit</Link></div>
        <div className="slide2"><Link to={constants.LINK_PRESS}>Best Prepaid Card Solutions at IAMAI India Digital Summit, 2019</Link></div>
        <div className="slide3"><Link to={constants.LINK_PRESS}>Best Prepaid Card of the Year At the 7th Edition of Payments &amp; Cards Summit 2019</Link></div>
      </div>
    </StyledNewsC>
  );
}

NewsCarousel.propTypes = {

};

export default NewsCarousel;



// WEBPACK FOOTER //
// client/components/NewsCarousel/index.js